import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export default function SsoExchangePage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('exchanging');
  const [error, setError] = useState(null);

  useEffect(() => {
    const ssoToken = params.get('token');
    const redirect = params.get('redirect') || '/dashboard';
    if (!ssoToken) {
      setStatus('error');
      setError('Brak tokenu SSO w URL');
      return;
    }
    (async () => {
      try {
        const r = await axios.post(`${API_URL}/auth/sso-exchange`, { token: ssoToken });
        const { access_token } = r.data;
        localStorage.setItem('aurabase_token', access_token);
        // Pełny reload — AuthContext bootstrapuje sesję z localStorage (GET /auth/me)
        window.location.href = redirect;
      } catch (e) {
        setStatus('error');
        setError(e?.response?.data?.detail || e.message);
      }
    })();
  }, [params]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-50 to-purple-50">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
        {status === 'exchanging' && (
          <>
            <Loader2 className="w-12 h-12 mx-auto mb-4 text-indigo-500 animate-spin" />
            <h1 className="text-xl font-semibold text-slate-900 mb-2">Logowanie z Sorto CRM...</h1>
            <p className="text-sm text-slate-500">Weryfikujemy Twoją tożsamość i przygotowujemy konto.</p>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-rose-100 flex items-center justify-center">
              <span className="text-rose-600 text-2xl">!</span>
            </div>
            <h1 className="text-xl font-semibold text-slate-900 mb-2">Logowanie SSO nieudane</h1>
            <p className="text-sm text-rose-600 mb-4">{error}</p>
            <button onClick={() => navigate('/login')} className="px-4 py-2 bg-slate-100 text-slate-700 rounded hover:bg-slate-200">
              Wróć do logowania
            </button>
          </>
        )}
      </div>
    </div>
  );
}
